import React from 'react';

function HighlightText({text}) {
    return (
        <span className='font-bold bg-gradient-to-r from-[#12D8FA] text-transparent via-[#12D8FA] via-[#1FA2FF] to-[#1FA2FF] bg-clip-text'>
            {" "}
            {text}
        </span>
    );
}

export default HighlightText;